/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Match_Tracker_DescriptionInputs */



/**
* | output |
* | --- |
* | "Points and XP for 2–4 players during a game" |
*
* @param {Nav_Match_Tracker_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_match_tracker_description = /** @type {((inputs?: Nav_Match_Tracker_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Match_Tracker_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Punkte und XP für 2–4 Spieler während einer Partie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points et XP pour 2 à 4 joueurs pendant une partie")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("对局中 2 到 4 名玩家的分数与经验")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在對局中記錄 2 至 4 位玩家的分數與經驗值")
	if (locale === "ko") return /** @type {LocalizedString} */ ("게임 중 2~4인의 점수와 경험치 기록")
	return /** @type {LocalizedString} */ ("Points and XP for 2–4 players during a game")
});